import { APIDirectory, HTTP } from "../../rest"

import * as TimeTableConstants from './TimeTableConstants'
export const getTimeTableProgress = () => {
    return {
        type: TimeTableConstants.GET_TIME_TABLE_IN_PROGRESS
    };
};

export const getTimeTableComplete = data => {
    return {
        type: TimeTableConstants.GET_TIME_TABLE_COMPLETE,
        data: data
    };
};


export const getTimeTableFailed = (error) => {
    return {
        type: TimeTableConstants.GET_TIME_TABLE_FAILED,
        data: error
    };
};

export const getTimeTableById = (timeTableId,typeId) => {
    return async dispatch => {
        try {
            dispatch(getTimeTableProgress());
            let url = APIDirectory.getTimeTableByIdAndTypeId(timeTableId, typeId);
            let timeTableData = await HTTP.GET(url);
            
            dispatch(getTimeTableComplete(timeTableData));
            return timeTableData;
        } catch (error) {
         
            dispatch(getTimeTableFailed(error));
            throw error
        }
    }
}
